(() => {
  const HOSTED_LOGIN = 'https://shopify.com/authentication/103978533206/login';
  const ACCOUNT_PATHS = new Set(['/account', '/account/', '/account/login', '/account/register', '/account/recover']);

  const needsFix = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      return url.hostname === 'account.driveeasymalta.com' ||
        (url.origin === window.location.origin && ACCOUNT_PATHS.has(url.pathname));
    } catch (error) {
      return false;
    }
  };

  const rewriteLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || !needsFix(href)) return;
      link.href = HOSTED_LOGIN;
      link.rel = 'nofollow';
      link.dataset.vitacoreAccountFixed = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteLinks, { once: true });
  } else {
    rewriteLinks();
  }

  new MutationObserver(rewriteLinks).observe(document.documentElement, { childList: true, subtree: true });
})();
